module.exports = __webpack_public_path__ + "img/pager2-quick-icon1.f1b110d1.png";